<div
  ngbDropdown
  class="d-inline-block"
  #dropdown="ngbDropdown"
  [autoClose]="autoClose"
  display="dynamic"
  [placement]="placement"
  (openChange)="dropdownOpenChange.emit($event)"
>
  <div
    ngbDropdownToggle
    class="dropdown__host"
    [ngClass]="{
      dropdown__select: selectStyle,
      'dropdown__select--compact': compact,
      'dropdown__select--extra-compact': extraCompact,
      'dropdown__select--active': selectStyle && dropdown.isOpen(),
      'dropdown__select--highlighted': highlight,
    }"
  >
    <ng-content select="[host]"></ng-content>
  </div>

  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
    <div class="dropdown__header" *ngIf="showHeader">
      <ng-content select="[menuLabel]"></ng-content>
    </div>
    <div class="dropdown__content">
      <ng-content selector=".dropdown-item"></ng-content>
      <ng-content select="[content]"></ng-content>
    </div>
    <div class="dropdown__footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
